var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

    pluginRegistry.registerFeature("Octopus.Features.TomcatStateManager", function() {
        return {
            title: "Start or Stop deployment in Tomcat",
            description: "Start or stop a deployment in Tomcat via the Manager API",
            editTemplateUrl: "areas/projects/features/Octopus.Features.TomcatStateManager_edit.html",
            preLink: function (scope) {
                if (!scope.action.Properties['Tomcat.Deploy.Debug']) {
                    scope.action.Properties['Tomcat.Deploy.Debug'] = "False";
                }

                if (scope.action.Properties['Tomcat.Deploy.Enabled'] != "True" &&
                    scope.action.Properties['Tomcat.Deploy.Enabled'] != "False") {
                    scope.action.Properties['Tomcat.Deploy.Enabled'] = "True";
                }

                if (!scope.action.Properties['Tomcat.Deploy.Controller']) {
                    scope.action.Properties['Tomcat.Deploy.Controller'] = "http://localhost:8080/manager";
                }
            },
            priority: 11,
            editLink: function($scope, element) {
            },
            enable: function(action, step) {
                action.Properties["Octopus.Features.TomcatStateManager"] = "True";
            },
            disable: function(action, step) {
                delete action.Properties["Octopus.Features.TomcatStateManager"];
            },
            validate: function(action, step, errors) {
                if (!action.Properties["Tomcat.Deploy.User"]) {
                    errors.push("Please enter the Tomcat Management User.");
                }
                if (!action.Properties["Tomcat.Deploy.Password"]) {
                    errors.push("Please enter the Tomcat Management Password.");
                }
                if (!action.Properties["Tomcat.Deploy.Controller"]) {
                    errors.push("Please enter the Tomcat Manager URL.");
                }
                if (!action.Properties["Tomcat.Deploy.Name"]) {
                    errors.push("Please enter the context path to modify the state of.");
                }
            }
        };
    });

});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.TomcatStateManager.js
// module id = 6026215755587107
// module chunks = 1